var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed"},[_c('div',{staticClass:"notice-content"},[(_vm.textNote)?_c('TextNote',{attrs:{"textNote":_vm.textNote,"artwork":_vm.artwork,"isSingleArtwork":true}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }